// extracted by mini-css-extract-plugin
export var acitonButtons = "_mf-0";
export var additionalIcon = "_mf-f";
export var block = "_mf-1";
export var blockContent = "_mf-7";
export var blockDescription = "_mf-8";
export var blockIcon = "_mf-9";
export var blockTitle = "_mf-6";
export var border = "_mf-a";
export var center = "_mf-l";
export var edge = "_mf-b";
export var edgeLabel = "_mf-c";
export var edgePath = "_mf-d";
export var error = "_mf-e";
export var flowchart = "_mf-g";
export var flowchartContent = "_mf-h";
export var highlighted = "_mf-3";
export var hover = "_mf-4";
export var icon = "_mf-i";
export var left = "_mf-m";
export var navButton = "_mf-j";
export var navButtons = "_mf-k";
export var right = "_mf-n";
export var selected = "_mf-2";
export var small = "_mf-5";